import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';
import { isString } from '@utils/guards';

import type {
  IAffiliatesApproveRequest,
} from '../types';
import {
  AFFILIATES_PENDING_APPROVE_MUTATION_KEY,
  AFFILIATES_PENDING_APPROVE_URL,
  AFFILIATES_PENDING_COUNT_QUERY_KEY,
  AFFILIATES_PENDING_LIST_QUERY_KEY,
  AFFILIATES_PENDING_PERMISSIONS,
} from '../constants';

export default function usePendingAffiliatesApproveMutation(): IContextMutationResult<
  void,
  Error,
  IAffiliatesApproveRequest
> {
  const { displayPresetToast } = useToastStore();
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IAffiliatesApproveRequest>({
    mutationKey: [AFFILIATES_PENDING_APPROVE_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPost<void>(
      AFFILIATES_PENDING_APPROVE_URL,
      payload,
      {
        permission: AFFILIATES_PENDING_PERMISSIONS.REQUEST,
        urlParams: { id },
      },
    ),
    onSuccess({ queryClient }) {
      displayPresetToast('success');
      void queryClient.invalidateQueries({
        predicate: (query) => isString(query.queryKey[0]) && [
          AFFILIATES_PENDING_LIST_QUERY_KEY,
          AFFILIATES_PENDING_COUNT_QUERY_KEY,
        ].includes(query.queryKey[0]),
      });
    },
  });
}
